// /Users/aminajackson/Git-projects/pro-maximizer/frontend/src/RiskRadar.tsx

import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  Chip,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@mui/material';
import {
  WarningAmber as WarningIcon,
  Timeline as TimelineIcon,
  ErrorOutline as ErrorIcon,
  TrendingUp as TrendingUpIcon,
} from '@mui/icons-material';

// Define the shape of a single risk item
export interface Risk {
  id: number;
  type: 'Stagnation' | 'Quality' | 'Timeline' | 'Velocity';
  message: string;
  severity: 'warning' | 'error' | 'info';
}

interface RiskRadarProps {
  risks: Risk[];
}

// Helper to map risk types to icons
const ICONS: { [key: string]: React.ReactElement } = {
  Stagnation: <TimelineIcon color="warning" />,
  Quality: <ErrorIcon color="error" />,
  Timeline: <WarningIcon color="warning" />,
  Velocity: <TrendingUpIcon color="info" />,
};

const RiskRadar: React.FC<RiskRadarProps> = ({ risks }) => (
  <Card sx={{ height: '100%' }}>
    <CardContent>
      <Typography variant="h6" gutterBottom>
        AI Risk Radar
      </Typography>
      {risks.length > 0 ? (
        <List disablePadding>
          {risks.map((risk, index) => (
            <React.Fragment key={risk.id}>
              <ListItem alignItems="flex-start" sx={{ py: 1.5 }}>
                <ListItemIcon sx={{ minWidth: 40, mt: 0.5 }}>
                  {ICONS[risk.type]}
                </ListItemIcon>
                <ListItemText
                  primary={risk.type}
                  secondary={risk.message}
                  primaryTypographyProps={{ fontWeight: 'bold', variant: 'body2' }}
                  secondaryTypographyProps={{ variant: 'body2', color: 'text.secondary' }}
                />
              </ListItem>
              {index < risks.length - 1 && <Divider variant="inset" component="li" />}
            </React.Fragment>
          ))}
        </List>
      ) : (
        <Box sx={{ textAlign: 'center', py: 4, color: 'text.secondary' }}>
          <Typography variant="body2">No risks detected at this time.</Typography>
          <Typography variant="caption">Connect a project or repo to begin analysis.</Typography>
        </Box>
      )}
    </CardContent>
  </Card>
);

export default RiskRadar;